import { useIsDesktop } from "@/hooks";
import { useFeatureFlagVariant } from "@/utils/kameleoon/useFeatureFlagVariant";
export function useStickyContactForm(variant) {
    const isDesktop = useIsDesktop();
    const isStickyContactFormEnabled = useFeatureFlagVariant("cdp_design_iteration_closed_form", variant);
    return isStickyContactFormEnabled && isDesktop;
}
